export default __webpack_public_path__ + "static/media/ForceSensorsImg.7edce308.jpg";